import AboutPage from "./components/AboutPage/AboutPage";
import LandingPage from "./components/LandingPage/LandingPage";

const config = {
  application: {
    name: "Rana Khalaily - Neuro",
    logo: "/static/images/microspec.svg",
    auth: {
      enableRegister: false,
    },
    commonConfig: {
      showOfflineDialog: false,
    },
    theme: {
      mode: "light",
      primary: {
        main: "#7393B3",
      },
    },
  },
  pages: [
    {
      path: "/",
      spec: {
        type: "Simple",
        object: <LandingPage />,
      },
    },
    {
      path: "/about",
      spec: {
        type: "Simple",
        object: <AboutPage />,
      },
    },
  ],
  dashboards: [],
  languages: {
    default: "he-IL",
    list: [
      { code: "ar-SA", name: "العربية" },
      { code: "he-IL", name: "עברית" },
      { code: "en-US", name: "English" },
    ],
  },
};

export default config;
